import { HttpRequestStatus } from 'model/enums/httpRequestStatus';
import { DownloadShareholderDocumentActionTypes, DownloadShareholderDocumentState } from 'reducer/shareholder/download-shareholder-document/types';
import { Reducer } from 'redux';

export const initialState: DownloadShareholderDocumentState = {
    status: HttpRequestStatus.NOOP,
    error: undefined,
    shareholderDocument: undefined
};

const reducer: Reducer<DownloadShareholderDocumentState> = (state = initialState, action): DownloadShareholderDocumentState => {
    switch (action.type) {
        case DownloadShareholderDocumentActionTypes.DOWNLOAD_SHAREHOLDER_DOCUMENT_REQUEST: {
            return { ...state, status: HttpRequestStatus.ONGOING, shareholderDocument: undefined, error: undefined };
        }
        case DownloadShareholderDocumentActionTypes.DOWNLOAD_SHAREHOLDER_DOCUMENT_SUCCESS: {
            return { ...state, status: HttpRequestStatus.SUCCESS, shareholderDocument: action.payload, error: undefined };
        }
        case DownloadShareholderDocumentActionTypes.DOWNLOAD_SHAREHOLDER_DOCUMENT_ERROR: {
            return { ...state, status: HttpRequestStatus.ERROR, error: action.payload };
        }
        case DownloadShareholderDocumentActionTypes.DOWNLOAD_SHAREHOLDER_DOCUMENT_RESET_STATE: {
            return { ...initialState };
        }
        default: {
            return state;
        }
    }
};

export { reducer as downloadShareholderDocumentReducer };
